/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT : EMBED ADs MOBILE PLACEMENT : STYLES --------------- ++++++++++ */
export default theme => ({
    mobile: {
        animationName: 'fadeInLeft',

        '& .visual': {
            '& .device': {
                backgroundImage: `url(${url.image}/mks/graphic-placement-mobile-blank-large.png)`,
                height:pxToEm(380),
                width:pxToEm(210),
                '& .embed-container': {
                    width: pxToEm(145),
                    top: pxToEm(42),
                    right: pxToEm(32),
                    '& .ad': {
                        '&.inline': {
                            height: pxToEm(88)
                        }
                    },
                    '& .embed': {
                        backgroundImage: `url(${url.image}/mks/graphic-embed-profiling-rail.png)`,
                        height: pxToEm(120)
                    }
                }
            }
        }
    }
});
